import i18n from '../../i18n';

export class Text {
  static milestones(year: string): string {
    return i18n._translate('%{year} Milestones', {
      context: 'A collection of achievements the user has collected for a given timeframe',
      year,
    });
  }

  static get workouts(): string {
    return i18n._translate('Workouts', { context: 'Text indicating how many workouts the user has performed' });
  }

  static get infoCurrentYear(): string {
    return i18n._translate(
      'Milestones are the total year-to-date count of completed iFIT workouts. This excludes manual workout types, as well as workouts imported from third parties.',
      { context: 'An explanation of how Milestones work for current year' }
    );
  }

  static infoPreviousYear(year: string): string {
    return i18n._translate(
      'Past-year milestones are the total count of completed iFIT workouts in %{year}. This excludes manual workout types, as well as workouts imported from third-party apps.',
      {
        context: 'An explanation of how Milestones work for previous year',
        year,
      }
    );
  }
}
